// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ipYG","icon":"styles_icon__16T_X"};